"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[347],{

/***/ 32045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _createContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70518);



/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */
const Container = (0,_createContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 70518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createContainer; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js + 1 modules
var generateUtilityClass = __webpack_require__(27621);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
var useThemeProps = __webpack_require__(29628);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createStyled.js + 6 modules
var createStyled = __webpack_require__(49950);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styled.js

const styled = (0,createStyled/* default */.ZP)();
/* harmony default export */ var esm_styled = (styled);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Container/createContainer.js


const _excluded = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"];








const defaultTheme = (0,createTheme/* default */.Z)();
const defaultCreateStyledComponent = esm_styled('div', {
  name: 'MuiContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`maxWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
  }
});
const useThemePropsDefault = inProps => (0,useThemeProps/* default */.Z)({
  props: inProps,
  name: 'MuiContainer',
  defaultTheme
});
const useUtilityClasses = (ownerState, componentName) => {
  const getContainerUtilityClass = slot => {
    return (0,generateUtilityClass/* default */.Z)(componentName, slot);
  };
  const {
    classes,
    fixed,
    disableGutters,
    maxWidth
  } = ownerState;
  const slots = {
    root: ['root', maxWidth && `maxWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fixed && 'fixed', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiContainer'
  } = options;
  const ContainerRoot = createStyledComponent(({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({
    width: '100%',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    marginRight: 'auto',
    display: 'block'
  }, !ownerState.disableGutters && {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }), ({
    theme,
    ownerState
  }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
    const breakpoint = breakpointValueKey;
    const value = theme.breakpoints.values[breakpoint];
    if (value !== 0) {
      // @ts-ignore
      acc[theme.breakpoints.up(breakpoint)] = {
        maxWidth: `${value}${theme.breakpoints.unit}`
      };
    }
    return acc;
  }, {}), ({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({}, ownerState.maxWidth === 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('xs')]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }
  }, ownerState.maxWidth &&
  // @ts-ignore module augmentation fails if custom breakpoints are used
  ownerState.maxWidth !== 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up(ownerState.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
    }
  }));
  const Container = /*#__PURE__*/react.forwardRef(function Container(inProps, ref) {
    const props = useThemeProps(inProps);
    const {
        className,
        component = 'div',
        disableGutters = false,
        fixed = false,
        maxWidth = 'lg'
      } = props,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    const ownerState = (0,esm_extends/* default */.Z)({}, props, {
      component,
      disableGutters,
      fixed,
      maxWidth
    });

    // @ts-ignore module augmentation fails if custom breakpoints are used
    const classes = useUtilityClasses(ownerState, componentName);
    return (
      /*#__PURE__*/
      // @ts-ignore theme is injected by the styled util
      (0,jsx_runtime.jsx)(ContainerRoot, (0,esm_extends/* default */.Z)({
        as: component
        // @ts-ignore module augmentation fails if custom breakpoints are used
        ,
        ownerState: ownerState,
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ref: ref
      }, other))
    );
  });
   false ? 0 : void 0;
  return Container;
}

/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G7": function() { return /* binding */ getContentFooterImageId; },
  "J1": function() { return /* binding */ getContentTags; },
  "Bu": function() { return /* binding */ getGeneralInformation; },
  "d": function() { return /* binding */ getHomeTopPageData; },
  "vf": function() { return /* binding */ getMenuItems; },
  "gu": function() { return /* binding */ getMilestones; },
  "Jq": function() { return /* binding */ getPosts; },
  "fu": function() { return /* binding */ getSupportPosts; },
  "cj": function() { return /* binding */ postBobbyApplication; },
  "w": function() { return /* binding */ postComment; },
  "QL": function() { return /* binding */ postLetterSubscription; },
  "sX": function() { return /* binding */ postVolunteerApplication; }
});

// UNUSED EXPORTS: getAssignmentDetail, getAudioDetail, getFaqOverviewData, getFaqs, getHomeData, getMilestonesPageData, getOpenLetter, getPostDetail, getTrainingDays, getVolunteerRegisterPageData

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./constants/endpoints.ts
const BASE_ENDPOINT = "https://admin.villapinedo.nl";
const endpoints_ENDPOINTS = {
    BASE: BASE_ENDPOINT,
    COLLECTIONS: "".concat(BASE_ENDPOINT, "/items"),
    FILES: "".concat(BASE_ENDPOINT, "/assets"),
    GRAPHQL: "".concat(BASE_ENDPOINT, "/graphql"),
    GRAPHQL_SYSTEM: "".concat(BASE_ENDPOINT, "/system/graphql")
};
// todo: delete ENDPOINTS once everything is working against the new CMS
// URLS is replacing ENDPOINTS
/* harmony default export */ var endpoints = (endpoints_ENDPOINTS);

// EXTERNAL MODULE: ./constants/urls.ts
var urls = __webpack_require__(26854);
;// CONCATENATED MODULE: ./api/api.ts



/**
 * Add a comment
 * @param type "forum" or "blog"
 * @param data
 */ const postComment = async (type, param)=>{
    let { post_id , ...rest } = param;
    await fetch("".concat(urls/* default.APP */.Z.APP, "/comment"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...rest,
            content: browser_default().sanitize(rest.content),
            ["".concat(type.includes("letter") ? type : "".concat(type, "_post"))]: post_id,
            status: "draft",
            entityType: type
        })
    });
};
/**
 * Get all the menu items used for navigation
 * @returns array or null
 */ const getMenuItems = async ()=>{
    try {
        const res = await fetch("".concat(urls/* default.APP */.Z.APP, "/menu-items"), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const resData = await res.json();
        return resData;
    } catch (error) {
        return null;
    }
};
/**
 * Get the general information of the website
 * @returns GeneralInformationTypes or null (if error)
 */ const getGeneralInformation = async ()=>{
    try {
        const response = await fetch("".concat(urls/* default.APP */.Z.APP, "/general-information"), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};
/**
 * get the top home page details
 *
 */ const getHomeTopPageData = async (param)=>{
    let { ageCategory , category , page  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/homepage/home-top-data-without-email?BlogPostCount=1&ForumCount=1&InstagramCount=1&ChatItemCount=1&AudioItemCount=1&VideoItemCount=1&AssignmentCount=1&OpenLetterCount=1");
    if (ageCategory) {
        url = "".concat(url, "&ageCategory=").concat(ageCategory);
    }
    if (category) {
        url = "".concat(url, "&category=").concat(category);
    }
    if (page) {
        url = "".concat(url, "&page=").concat(page);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Get the assignment items
 */ const getAssignmentDetail = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/assignments?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : result[0];
};
/**
 * Add a letter subscription
 * @param data
 */ const postLetterSubscription = async (data)=>{
    await fetch("".concat(endpoints.COLLECTIONS, "/letter_submissions"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
};
const getSupportPosts = async (param)=>{
    let { typeContent , sort , search , category , postPerPage , page  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/support-overview-page/entities");
    let prepend = "?";
    if (postPerPage) {
        url = "".concat(url).concat(prepend, "maxresultcount=").concat(postPerPage);
        prepend = "&";
    }
    if (page) {
        url = "".concat(url).concat(prepend, "page=").concat(page);
    }
    if (search) {
        url = "".concat(url).concat(prepend, "search=").concat(search);
    }
    if (category) {
        url = "".concat(url).concat(prepend, "category=").concat(category);
    }
    if (sort) {
        url = "".concat(url).concat(prepend, "sort=").concat(sort);
    }
    if (typeContent) {
        url = "".concat(url).concat(prepend, "typeContent=").concat(typeContent);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets a list of blog posts
 * @param postPerPage the amount of posts to be shown per page
 * @param page the current paginated page
 * @returns
 */ const getPosts = async (param)=>{
    let { sort , filter , page , search , category , signal  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/blog-posts");
    let prepend = "?";
    if (page) {
        url = "".concat(url).concat(prepend, "page=").concat(page);
        prepend = "&";
    }
    if (search) {
        url = "".concat(url).concat(prepend, "search=").concat(search);
    }
    if (sort) {
        url = "".concat(url, "&sort=").concat(sort);
    }
    if (filter) {
        url = "".concat(url, "&").concat(filter);
    }
    if (category) {
        url = "".concat(url, "&category=").concat(category);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
        signal
    });
};
/*get a list of tips */ /**
 * Get the post detail base on the slug
 * @param slug the post slug
 * @returns
 */ const getPostDetail = async (slug)=>{
    var _result_data;
    const response = await fetch("".concat(URLS.APP, "/blog-posts?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data[0];
};
/**
 * Get the audio detail base on the slug
 * @param slug the post slug
 * @returns
 */ const getAudioDetail = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/audio-items?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : result[0];
};
/**
 * Gets the data for the homepage
 * @returns
 */ const getHomeData = async function() {
    let isForAdults = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const searchParams = new URLSearchParams({
        isForAdults: isForAdults.toString()
    });
    return await fetch("".concat(URLS.APP, "/homepage?").concat(searchParams), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Add a volunteer application
 * @param data
 */ const postVolunteerApplication = async (data)=>{
    await fetch("".concat(urls/* default.APP */.Z.APP, "/volunteer-registration-form"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...data
        })
    });
};
const postBobbyApplication = async (data)=>{
    return fetch("".concat(urls/* default.APP */.Z.APP, "/kid-registration"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...data,
            // Set the birthdate to a string in YYYY-MM-DD format
            birthdate: new Date(data.birthdate).toISOString().split("T")[0]
        })
    });
};
/**
 * Gets all available tags
 */ const getContentTags = async ()=>{
    let url = "".concat(urls/* default.APP */.Z.APP, "/theme?MaxResultCount=999&status=1");
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets a list of faq items
 * @param postPerPage the amount of items to be shown per page
 * @returns
 */ const getFaqs = async (param)=>{
    let { // postPerPage,
    // page = 1,
    search , sort , filter , meta ="total_count" , type ="volunteer_faq"  } = param;
    let url = "".concat(ENDPOINTS.COLLECTIONS, "/faq_items?fields=*.*.*?filter[status][_eq]=published&filter[type][_eq]=").concat(type);
    if (meta) {
        url = "".concat(url, "&meta=").concat(meta);
    }
    if (search) {
        url = "".concat(url, "&search=").concat(search);
    }
    if (sort) {
        url = "".concat(url, "&sort=").concat(sort);
    }
    if (filter) {
        url = "".concat(url, "&").concat(filter);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets the data for the faq overview page
 * @returns
 */ const getFaqOverviewData = async ()=>{
    return await fetch("".concat(ENDPOINTS.COLLECTIONS, "/faq_overview_page?fields=*.*"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Get the page data for the milestones page.
 *
 * @returns MilestonesPageData
 */ const getMilestonesPageData = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/milestones-page"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const data = await response.json();
    return data;
};
/**
 * Get all the milestones
 *
 * @returns MilestoneType[]
 */ const getMilestones = async (skipCount, maxResultCount)=>{
    const response = await fetch("".concat(urls/* default.APP */.Z.APP, "/milestone?SkipCount=").concat(skipCount, "&MaxResultCount=").concat(maxResultCount, "&Sorting=order"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
const getContentFooterImageId = async ()=>{
    const req = getGeneralInformation();
    return req.then((res)=>{
        return res === null || res === void 0 ? void 0 : res.contentFooterImageId;
    });
};
/**
 * Get an open letter by slug.
 * @param slug
 * @returns Promise<any> - The open letter data
 */ const getOpenLetter = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/open-letter/by-slug?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
/**
 * Get the page data for the volunteer register page.
 *
 * @returns Promise<any> - The page data
 */ const getVolunteerRegisterPageData = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/volunteer-register"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
/**
 * Get the volunteer training days.
 *
 * @returns Promise<any> - The training days
 */ const getTrainingDays = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/volunteer-training-day/volunteer-training-days"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};


/***/ }),

/***/ 26854:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const BASE_URL = "https://abp.villapinedo.nl";
const URLS = {
    BASE: BASE_URL,
    CMSKIT: "".concat(BASE_URL, "/api/cms-kit"),
    FILE: "".concat(BASE_URL, "/api/file"),
    APP: "".concat(BASE_URL, "/api/app"),
    ADULTS: "https://volwassenen.villapinedo.nl",
    PAGES: {
        OPEN_LETTERS_PARENTS: "/open-brieven-ouders",
        MEDIA_REPORTS: "/mediaberichten",
        MEDIA_REPORTS_DETAIL: "/in-de-media",
        VACANCIES: "/vacatures",
        SPONSOR_BUDDY_FORM: "/sponsor-een-buddy/buddy-sponsoren-aanmelden",
        TIPS: "/tips",
        STORIES: "/verhalen",
        INFORMATION: "/informatie",
        FORUM_PARENTS: "/forum_ouders",
        FORUM_CHILDREN: "/forum",
        ASK_A_QUESTION_CHILDREN: "/stel-een-vraag",
        ASK_A_QUESTION_PARENTS: "/stel-een-vraag-ouders"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (URLS);


/***/ })

}]);